<div class="summary-grid" [class.summary-grid--single]="!!section">

  <div class="summary-main" *ngIf="!section || section === 'freight'">

  <!-- Сюда родитель проецирует карточку товаров (редактор инвойса) -->
  <ng-content></ng-content>

  <!-- ─── Информация о поставке ─────────────────────────────────────────── -->
  <div class="summary-card summary-card--shipment" [class.summary-card--freight]="section === 'freight' || mode === 'pending'">
    <h3 class="summary-card__title" *ngIf="section !== 'freight' && mode !== 'pending'">{{ shipmentInfoTitleText }}</h3>

    <form [formGroup]="shipmentForm" class="shipment-form">
      <fieldset class="form-group-box">
        <legend>{{ groupRouteText }}</legend>
        <div class="form-row">
          <div class="form-field">
            <label>{{ fromCountryLabelText }}</label>
            <app-country-select formControlName="fromCountryId" [countries]="countries" [placeholder]="countryNotSpecifiedText"></app-country-select>
          </div>
          <div class="form-field">
            <label>{{ fromCityLabelText }}</label>
            <input type="text" formControlName="fromCity" class="form-control" [placeholder]="cityPlaceholderText" autocomplete="off" />
          </div>
        </div>

        <div class="form-row">
          <div class="form-field">
            <label>{{ toCountryLabelText }}</label>
            <app-country-select formControlName="toCountryId" [countries]="countries" [placeholder]="countryNotSpecifiedText"></app-country-select>
          </div>
          <div class="form-field">
            <label>{{ toCityLabelText }}</label>
            <input type="text" formControlName="toCity" class="form-control" [placeholder]="cityPlaceholderText" autocomplete="off" />
          </div>
        </div>
      </fieldset>

      <fieldset class="form-group-box">
        <legend>{{ groupCargoText }}</legend>
        <div class="form-row">
          <div class="form-field">
            <label>{{ totalWeightLabelText }}</label>
            <input type="number" inputmode="decimal" min="0" step="0.001" formControlName="totalWeightKg" class="form-control" placeholder="0" />
          </div>
          <div class="form-field">
            <label>{{ totalVolumeLabelText }}</label>
            <input type="number" inputmode="decimal" min="0" step="0.001" formControlName="totalVolumeM3" class="form-control" placeholder="0" />
          </div>
        </div>

        <div class="form-row">
          <div class="form-field">
            <label>{{ transportTypeLabelText }}</label>
            <select formControlName="transportType" class="form-control">
              <option *ngFor="let opt of transportTypeOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
          </div>
        </div>
      </fieldset>

      <div class="delivery-cost-section">
        <h4 class="delivery-cost-section__title">{{ deliveryCostSectionTitleText }}</h4>
        <p class="delivery-cost-section__hint">{{ deliveryCostHintText }}</p>

        <div class="delivery-actions" *ngIf="!viewOnly">
          <button
            type="button"
            class="btn-estimate-delivery"
            [disabled]="!canEstimateDelivery || estimatingDelivery"
            [title]="!canEstimateDelivery ? estimateDeliveryRequiresSaveText : ''"
            (click)="onEstimateDeliveryCost()"
          >
            {{ estimatingDelivery ? estimatingDeliveryText : estimateDeliveryButtonText }}
          </button>
          <!-- Кабинет клиента: стоимость известна — вводит сам, платежи считаем по ней -->
          <button type="button" class="btn-manual-freight" *ngIf="section === 'freight' && !manualOpen" (click)="openManualFreight()">
            {{ st('calculationSummary.manualFreightOpen', 'Знаю стоимость — введу сам') }}
          </button>
        </div>

        <div class="manual-freight" *ngIf="section === 'freight' && manualOpen && !viewOnly">
          <label class="manual-freight__label" for="manual-freight-amount">{{ st('calculationSummary.manualFreightLabel', 'Стоимость доставки до границы (аэропорта) Казахстана') }}</label>
          <div class="manual-freight__row">
            <input id="manual-freight-amount" type="number" inputmode="decimal" min="0" step="0.01" class="form-control manual-freight__amount"
                   [(ngModel)]="manualAmount" [ngModelOptions]="{ standalone: true }" placeholder="0" (keydown.enter)="applyManualFreight()" />
            <select class="form-control manual-freight__currency" [(ngModel)]="manualCurrency" [ngModelOptions]="{ standalone: true }">
              <option *ngFor="let cur of manualCurrencies" [value]="cur">{{ cur }}</option>
            </select>
            <button type="button" class="btn-estimate-delivery" (click)="applyManualFreight()">{{ st('calculationSummary.manualFreightApply', 'Применить') }}</button>
            <button type="button" class="btn-link-plain" (click)="manualOpen = false">{{ st('common.cancel', 'Отмена') }}</button>
          </div>
          <p class="manual-freight__hint">{{ st('calculationSummary.manualFreightHint', 'Эта сумма войдёт в таможенную стоимость, и платежи пересчитаются. Знаете только общую сумму доставки — укажите её.') }}</p>
          <p class="manual-freight__error" *ngIf="manualError" role="alert">{{ manualError }}</p>
        </div>
        <p class="delivery-cost-section__warning" *ngIf="!canEstimateDelivery && !estimatingDelivery && !viewOnly">
          <svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="7.5"/><path d="M10 9v4.5M10 6.5v.01"/></svg>
          <span>{{ estimateDeliveryRequiresSaveText }}</span>
        </p>
        <div *ngIf="deliveryEstimateError" class="delivery-cost-section__error">{{ deliveryEstimateError }}</div>

        <div class="delivery-result" *ngIf="hasDeliveryEstimate">
          <div class="delivery-result__header">
            <h5 class="delivery-result__title">{{ deliveryResultTitleText }}</h5>
            <a
              class="delivery-result__justification-link"
              *ngIf="hasDeliveryJustification"
              (click)="onShowDeliveryJustificationModal()"
            >{{ deliveryJustificationLinkText }}</a>
          </div>

          <div class="delivery-amount-row">
            <label>{{ isManualFreight && section === 'freight' ? st('calculationSummary.manualFreightResult', 'Ваша стоимость доставки') : deliveryTotalLabelText }}</label>
            <span class="delivery-amount-row__value">{{ deliveryTotalAmount | number:'1.0-2' }} {{ calculation?.freightCurrencyCode }}</span>
            <span class="delivery-amount-row__note">{{ customsValueNoteText }}</span>
          </div>
        </div>

        <!-- Кабинет клиента: прогноз ИИ — ориентир; точные ставки перевозчиков — в сопровождении -->
        <div class="delivery-ai-note" *ngIf="section === 'freight' && hasDeliveryEstimate && !isManualFreight">
          <svg class="delivery-ai-note__icon" viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="7.5"/><path d="M10 9v4.5M10 6.5v.01"/></svg>
          <div>
            <p class="delivery-ai-note__title">{{ st('calculationSummary.aiForecastTitle', 'Это прогноз искусственного интеллекта — реальная цена может отличаться.') }}</p>
            <p class="delivery-ai-note__text">{{ st('calculationSummary.aiForecastText', 'Точную стоимость рассчитают реальные перевозчики: в платном сопровождении Bilload вы получите их ставки и выберете лучшее предложение.') }}</p>
            <a class="delivery-ai-note__link" *ngIf="calculation && (!calculation.status || calculation.status === 'CREATED')"
               [routerLink]="['/calculations', calculation.id, 'support']">
              {{ st('calcSections.startShipment', 'Заказать сопровождение') }}
              <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10h12M11 5l5 5-5 5"/></svg>
            </a>
          </div>
        </div>
      </div>

      <div class="shipment-form__footer" *ngIf="mode === 'loaded' && !viewOnly">
        <span class="unsaved-hint" *ngIf="isDirty && !saving">{{ unsavedHintText }}</span>
        <span class="saved-hint" *ngIf="!isDirty && !saving">{{ savedHintText }}</span>
        <button
          type="button"
          class="btn-save"
          [disabled]="saving || !isDirty"
          (click)="onSaveShipmentInfo()"
        >
          {{ saving ? savingButtonText : saveButtonText }}
        </button>
      </div>
    </form>
  </div>

  </div><!-- /.summary-main -->

  <!-- ─── Раздел «Разрешительные документы» в кабинете: только статус проверки ── -->
  <div class="summary-card summary-card--permits" *ngIf="section === 'permits'">
    <div class="permit-status" [ngClass]="'permit-status--' + restrictionsStatus" *ngIf="!isPending" [ngSwitch]="restrictionsStatus">
      <span class="permit-status__icon" aria-hidden="true">
        <svg *ngSwitchCase="'clear'" viewBox="0 0 24 24"><path d="M6 12.5l4 4 8-9"/></svg>
        <svg *ngSwitchCase="'restricted'" viewBox="0 0 24 24"><path d="M8 3h6l5 5v13H8z"/><path d="M14 3v5h5M11 13h5M11 17h5"/></svg>
        <span *ngSwitchCase="'processing'" class="restrictions__spinner"></span>
        <svg *ngSwitchDefault viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><path d="M12 11v5M12 8v.01"/></svg>
      </span>

      <div class="permit-status__body">
        <ng-container *ngSwitchCase="'clear'">
          <strong>{{ st('calcSections.permitsClearTitle', 'Разрешительные документы не требуются') }}</strong>
          <p>{{ restrictionsClearText }}</p>
        </ng-container>
        <ng-container *ngSwitchCase="'restricted'">
          <strong>{{ st('calcSections.permitsNeededTitle', 'Нужны разрешительные документы') }}</strong>
          <p>{{ st('calcSections.permitsNeededText', 'Для части товаров нужны документы — список по каждому товару ниже.') }}</p>
        </ng-container>
        <ng-container *ngSwitchCase="'processing'">
          <strong>{{ restrictionsCheckingText }}</strong>
          <p>{{ calculation?.certificatesProcessingMessage || st('calcSections.permitsWait', 'Это займёт около минуты.') }}</p>
        </ng-container>
        <ng-container *ngSwitchCase="'not-checked'">
          <strong>{{ st('calcSections.permitsNotCheckedTitle', 'Проверка ещё не проводилась') }}</strong>
          <p>{{ restrictionsAnalysisPendingText }}</p>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <strong>{{ st('calcSections.permitsUnknownTitle', 'Проверим после определения кодов') }}</strong>
          <p>{{ restrictionsUnknownText }}</p>
        </ng-container>
      </div>

      <button type="button" class="permit-status__btn" *ngIf="!viewOnly && (restrictionsStatus === 'clear' || restrictionsStatus === 'restricted')"
              (click)="onRunCertificatesCheck()" [title]="restrictionsRefreshTitleText">
        <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M16 10a6 6 0 1 1-1.8-4.3M16 3.5v3.5h-3.5"/></svg>
        {{ st('calcSections.permitsRecheck', 'Проверить заново') }}
      </button>
      <button type="button" class="permit-status__btn permit-status__btn--primary" *ngIf="!viewOnly && restrictionsStatus === 'not-checked'"
              (click)="onRunCertificatesCheck()">{{ restrictionsRunCheckText }}</button>
    </div>
  </div>

  <!-- ─── Результаты расчёта ────────────────────────────────────────────── -->
  <aside class="summary-card summary-card--results" [class.summary-card--payments]="section === 'payments' || mode === 'pending'" *ngIf="!section || section === 'payments'">
    <div class="results-header">
      <h3 class="summary-card__title">{{ resultsTitleText }}</h3>
      <span class="badge" [class.badge--pending]="isPending">
        {{ isPending ? calculatingBadgeText : preliminaryBadgeText }}
      </span>
    </div>

    <div class="total-block">
      <span class="total-block__label">{{ totalLabelText }}</span>
      <span class="total-block__value" [class.skeleton]="isPending">
        <ng-container *ngIf="!isPending">{{ money(totalPayments) }} ₸</ng-container>
      </span>
    </div>

    <!-- В разделе «Таможенные платежи» статус документов не дублируем — у него свой раздел -->
    <ng-container *ngIf="!section"><ng-container *ngTemplateOutlet="restrictionsTpl"></ng-container></ng-container>

    <div class="excise-notice" *ngIf="!isPending && calculation?.hasExciseExcludedProducts">
      ⚠ {{ exciseNoticeText }}
    </div>

    <ul class="payments">
      <li class="pay-row" *ngFor="let row of paymentRows">
        <div class="pay-row__top">
          <span class="pay-row__label">{{ row.label }}</span>
          <span class="pay-row__value" [class.skeleton]="isPending">
            <ng-container *ngIf="!isPending">{{ money(row.value) }} ₸</ng-container>
          </span>
        </div>
        <div class="pay-row__bar" *ngIf="!section && !isPending && (row.value || 0) > 0" aria-hidden="true">
          <span [style.width.%]="share(row.value)"></span>
        </div>
      </li>
      <li class="pay-total">
        <span>{{ totalRowText }}</span>
        <strong [class.skeleton]="isPending">
          <ng-container *ngIf="!isPending">{{ money(totalPayments) }} ₸</ng-container>
        </strong>
      </li>
    </ul>

    <details class="excise-exclusions" *ngIf="!section && mode !== 'pending'">
      <summary>{{ exclusionsSummaryText }}</summary>
      <ul>
        <li>{{ exclusion1Text }}</li>
        <li>{{ exclusion2Text }}</li>
      </ul>
      <p class="excise-exclusions__note">{{ exclusionsNoteText }}</p>
    </details>

    <button type="button" class="btn-details" *ngIf="detailsAvailable" (click)="onToggleDetails()">
      {{ detailsOpen ? ('▲ ' + hideDetailsButtonText) : ('▼ ' + showDetailsButtonText) }}
    </button>
  </aside>

</div>

<!-- ─── Модалка «Подробнее»: разрешительные документы по кодам ТНВЭД ─────── -->
<div class="restrictions-modal-overlay" *ngIf="showRestrictionsModal" (click)="closeRestrictionsModal()">
  <div class="restrictions-modal" (click)="$event.stopPropagation()">
    <div class="restrictions-modal__header">
      <h3>{{ restrictionsModalTitleText }}</h3>
      <button type="button" class="restrictions-modal__close" (click)="closeRestrictionsModal()">✕</button>
    </div>
    <ul class="restrictions-modal__list">
      <li *ngFor="let row of restrictionsModalRows">
        <strong>{{ row.code }}</strong> — {{ row.hasDocuments ? restrictionsModalRequiredText : restrictionsModalNotRequiredText }}
      </li>
    </ul>
  </div>
</div>

<!-- ─── Модалка «Обоснование»: из чего складывается AI-оценка доставки ───── -->
<div class="restrictions-modal-overlay" *ngIf="showDeliveryJustificationModal" (click)="closeDeliveryJustificationModal()">
  <div class="restrictions-modal" (click)="$event.stopPropagation()">
    <div class="restrictions-modal__header">
      <h3>{{ deliveryJustificationModalTitleText }}</h3>
      <button type="button" class="restrictions-modal__close" (click)="closeDeliveryJustificationModal()">✕</button>
    </div>
    <p class="delivery-justification-modal__notes" *ngIf="deliveryJustificationNotes">{{ deliveryJustificationNotes }}</p>
    <ul class="restrictions-modal__list delivery-justification-modal__list" *ngIf="deliveryJustificationBreakdown.length">
      <li *ngFor="let item of deliveryJustificationBreakdown">
        <span>{{ item.label }}</span>
        <strong>{{ item.amountUsd != null ? (item.amountUsd | number:'1.0-2') + ' USD' : deliveryJustificationNoAmountText }}</strong>
      </li>
    </ul>
  </div>
</div>

<!-- ─── Статус проверки разрешительных документов ─────────────────────────── -->
<ng-template #restrictionsTpl>
    <div class="restrictions" *ngIf="!isPending" [ngSwitch]="restrictionsStatus">
      <div class="restrictions__badge restrictions__badge--clear" *ngSwitchCase="'clear'">
        <span>✓ {{ restrictionsClearText }}</span>
        <span class="restrictions__actions">
          <a class="restrictions__more-link" (click)="onShowRestrictionsModal()">{{ restrictionsMoreDetailsText }}</a>
          <button type="button" class="restrictions__refresh-btn" [title]="restrictionsRefreshTitleText" (click)="onRunCertificatesCheck()">⟳</button>
        </span>
      </div>
      <div class="restrictions__badge restrictions__badge--restricted" *ngSwitchCase="'restricted'">
        <span>⚠ {{ restrictionsRestrictedText }}</span>
        <span class="restrictions__actions">
          <a class="restrictions__more-link restrictions__more-link--restricted" (click)="onShowRestrictionsModal()">{{ restrictionsMoreDetailsText }}</a>
          <button type="button" class="restrictions__refresh-btn restrictions__refresh-btn--restricted" [title]="restrictionsRefreshTitleText" (click)="onRunCertificatesCheck()">⟳</button>
        </span>
      </div>
      <div class="restrictions__badge restrictions__badge--pending" *ngSwitchCase="'processing'">
        <span class="restrictions__spinner"></span>
        {{ calculation?.certificatesProcessingMessage || restrictionsCheckingText }}
      </div>
      <div class="restrictions__badge restrictions__badge--pending" *ngSwitchCase="'not-checked'">
        <span>{{ restrictionsAnalysisPendingText }}</span>
        <button type="button" class="restrictions__check-btn" (click)="onRunCertificatesCheck()">
          {{ restrictionsRunCheckText }}
        </button>
      </div>
      <div class="restrictions__badge restrictions__badge--unknown" *ngSwitchDefault>
        {{ restrictionsUnknownText }}
      </div>
    </div>
</ng-template>
